import CustomButton from '@/shared/components/CustomButton';
import CustomEmptyState from '@/shared/components/CustomEmptyState';
import { retryLogin } from './keycloak';

export function AuthSessionError() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <CustomEmptyState
        icon="info-circle"
        title="ورود ناموفق بود"
        className="w-full"
        action={
          <CustomButton size="lg" onClick={retryLogin}>
            تلاش مجدد
          </CustomButton>
        }
      />
    </div>
  );
}
